// Mock data for Trademark Registration Website

export const mockFormSubmissions = [];

export const submitContactForm = (formData) => {
  const submission = {
    id: Date.now(),
    ...formData,
    submittedAt: new Date().toISOString(),
  };
  mockFormSubmissions.push(submission);
  console.log('Form submitted:', submission);
  return { success: true, message: 'Thank you! We will contact you shortly.' };
};

export const heroData = {
  title: 'Protect Your Brand with Professional Trademark Registration',
  subtitle: 'Expert USPTO Filing Services - Fast, Reliable, and Affordable',
  cta: 'Register My Trademark',
  image: 'https://images.unsplash.com/photo-1497366754035-f200968a6e72?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwxfHxsZWdhbCUyMG9mZmljZXxlbnwwfHx8fDE3NzU4NjA4NDh8MA&ixlib=rb-4.1.0&q=85',
};

export const companyInfo = {
  name: 'Trademark Service Company',
  email: 'info@trademarkservicecompany.com',
  phone: '+1 (123) 123-4567',
  address: '1420 Kettner Blvd suite 100, San Diego, CA 92101',
};

export const aboutData = {
  title: 'About Trademark Service Company',
  description: 'We are a leading trademark registration service provider in the United States, dedicated to protecting brands and intellectual property. With years of experience in USPTO filing procedures, our expert team has successfully registered thousands of trademarks for businesses of all sizes. We combine legal expertise with personalized service to ensure your brand receives the protection it deserves.',
  stats: [
    { value: '1000+', label: 'Trademarks Filed' },
    { value: '98%', label: 'Success Rate' },
    { value: '500+', label: 'Happy Clients' },
    { value: '10+', label: 'Years Experience' },
  ],
};

export const trademarkOverview = {
  title: 'What is Trademark Registration?',
  content: 'Trademark registration is the legal process of securing exclusive rights to your brand identity through the United States Patent and Trademark Office (USPTO). A registered trademark provides federal protection for your brand name, logo, slogan, or any distinctive mark that identifies your goods or services in the marketplace. This protection is crucial in today\'s competitive business environment where brand recognition and consumer trust are paramount to success.',
  points: [
    {
      title: 'Exclusive Legal Rights',
      description: 'Registration grants you exclusive nationwide rights to use your mark in connection with your specific goods or services. This means no one else can legally use a confusingly similar mark in your industry, protecting your market position and preventing customer confusion.'
    },
    {
      title: 'Federal Legal Protection',
      description: 'A registered trademark creates a public record of your ownership and provides legal presumption of your right to use the mark. This federal protection enables you to take legal action in federal court against infringers and seek statutory damages, attorney fees, and injunctive relief.'
    },
    {
      title: 'Nationwide Coverage',
      description: 'Unlike common law rights that are limited to geographic areas where you use your mark, federal registration provides protection across all 50 states, even in areas where you don\'t yet operate. This is essential for businesses planning expansion or operating online with nationwide reach.'
    },
    {
      title: 'Valuable Business Asset',
      description: 'Your registered trademark becomes a valuable intangible asset that increases in value as your business grows. It can be licensed to generate revenue, used as collateral for financing, sold or transferred, and significantly enhances your business valuation for investors or potential buyers.'
    },
    {
      title: 'Consumer Trust & Recognition',
      description: 'The ® symbol signals to consumers that your brand is legitimate, established, and legally protected. This builds consumer confidence, enhances brand recognition, and distinguishes your products or services from competitors in the marketplace.'
    },
    {
      title: 'Long-term Protection',
      description: 'Once registered, your trademark can last indefinitely as long as you continue using it in commerce and file the required maintenance documents. This perpetual protection ensures your brand investment is secured for generations, unlike patents or copyrights which have limited terms.'
    }
  ]
};

export const servicesData = [
  {
    title: 'Comprehensive Trademark Search',
    description: 'Before filing your trademark application, we conduct an exhaustive search of the USPTO database, state registrations, common law sources, and business directories to identify potential conflicts. Our multi-layered search process examines phonetic similarities, visual resemblances, and conceptual overlaps that could result in rejection.',
    features: [
      'Federal USPTO database search covering all registered and pending marks',
      'State trademark registry searches across all 50 states',
      'Common law usage investigation through business directories and domain registrations',
      'International trademark database screening for global conflicts',
      'Detailed analysis report with conflict assessment and registration likelihood',
      'Strategic recommendations for mark modification if conflicts exist'
    ],
    icon: 'Search',
  },
  {
    title: 'Professional Trademark Filing',
    description: 'Our trademark experts prepare and file your application with meticulous attention to detail, ensuring compliance with all USPTO requirements. We handle the complex classification system, draft precise descriptions of goods and services, select appropriate filing bases, and compile required specimens of use.',
    features: [
      'Accurate selection from 45 international trademark classes',
      'Precise drafting of goods and services descriptions for maximum protection',
      'Strategic filing basis selection (use in commerce or intent to use)',
      'Proper specimen preparation demonstrating commercial use',
      'Complete application review before submission to prevent errors',
      'Electronic filing with immediate confirmation and tracking number'
    ],
    icon: 'FileText',
  },
  {
    title: 'Office Action Response & Legal Strategy',
    description: 'When the USPTO issues an office action raising objections or requiring clarifications, our experienced team crafts persuasive legal arguments to overcome refusals. We analyze examiner objections, research supporting precedents, and develop strategic responses that maximize approval chances.',
    features: [
      'Expert analysis of all office action issues and refusal grounds',
      'Legal research of TMEP guidelines and relevant case law',
      'Persuasive written arguments addressing examiner concerns',
      'Amendment of descriptions or drawings when strategically beneficial',
      'Evidence gathering to demonstrate acquired distinctiveness',
      'Multiple response rounds if needed to secure registration'
    ],
    icon: 'Shield',
  },
  {
    title: 'Trademark Monitoring & Watch Services',
    description: 'After registration, we provide ongoing monitoring of new trademark applications filed with the USPTO to identify potential infringers attempting to register confusingly similar marks. Our watch service enables early detection and intervention to protect your brand from dilution.',
    features: [
      'Weekly monitoring of new USPTO trademark applications',
      'Automated alerts when similar marks are filed in related classes',
      'Analysis of potential conflict severity and threat level',
      'Deadline tracking for opposition filing (30-day window)',
      'Competitor trademark activity monitoring in your industry',
      'Comprehensive quarterly reports on trademark landscape'
    ],
    icon: 'Eye',
  },
  {
    title: 'Brand Protection & Enforcement',
    description: 'We help you actively protect your trademark rights through enforcement actions against unauthorized users. Our services include cease and desist letters, opposition proceedings, cancellation actions, and coordination with legal counsel for litigation support when necessary.',
    features: [
      'Professional cease and desist letter drafting and delivery',
      'Opposition proceedings against conflicting pending applications',
      'Cancellation petitions against improperly registered marks',
      'Domain name dispute resolution (UDRP proceedings)',
      'Customs and border protection recordation for import blocking',
      'Evidence collection and documentation of infringement'
    ],
    icon: 'Lock',
  },
  {
    title: 'Trademark Maintenance & Renewals',
    description: 'Maintaining your trademark registration requires timely filing of declarations of use and renewal applications at specific intervals. We manage all deadlines and filing requirements to ensure your registration remains active and enforceable throughout its lifetime.',
    features: [
      'Section 8 Declaration of Use filing (5-6 years after registration)',
      'Section 9 Renewal application (9-10 years after registration)',
      'Combined Section 8 & 15 filing for incontestability (5-6 years)',
      'Subsequent 10-year renewal filings for perpetual protection',
      'Deadline monitoring and advance reminder notifications',
      'Specimen gathering and use documentation for maintenance filings'
    ],
    icon: 'CheckCircle',
  },
];

export const whyChooseUs = [
  {
    title: 'USPTO Filing Experts with Proven Track Record',
    description: 'Our team consists of trademark specialists with extensive experience in USPTO procedures, examination guidelines, and appeal processes. We stay current with the latest TMEP updates, policy changes, and examiner trends to provide cutting-edge service. Our decade of experience has taught us the nuances that make the difference between approval and rejection.',
    stats: '10+ years experience'
  },
  {
    title: 'Industry-Leading 98% Approval Rate',
    description: 'We maintain an exceptional 98% success rate through meticulous application preparation, comprehensive pre-filing searches, and strategic response to office actions. Our thorough vetting process and attention to detail ensure your application meets all legal requirements before submission, minimizing delays and rejections that cost time and money.',
    stats: '98% success rate'
  },
  {
    title: 'Dedicated Case Manager & Personalized Service',
    description: 'Every client receives a dedicated case manager who guides them through the entire registration process from initial consultation to final registration. Your case manager is your single point of contact, ensuring consistent communication, timely updates, and personalized attention. We believe in building relationships, not just processing applications.',
    stats: '1-on-1 support'
  },
  {
    title: 'Transparent All-Inclusive Pricing',
    description: 'Our pricing is straightforward with no hidden fees, surprise charges, or fine print gotchas. Every package clearly outlines what\'s included, from search to filing to monitoring. We believe in transparency and will always inform you upfront of any additional costs like USPTO filing fees or optional services, so you can budget with confidence.',
    stats: 'No hidden fees'
  },
  {
    title: 'Fast Processing & Priority Service',
    description: 'We understand that timing matters in business. Our streamlined process expedites your application preparation and filing without sacrificing quality. Most applications are prepared and filed within 24-48 hours of receiving your information. Our priority service option puts your application at the front of the queue for same-day processing when speed is critical.',
    stats: '24-48 hour filing'
  },
  {
    title: 'Comprehensive Full-Service Protection',
    description: 'We offer complete trademark lifecycle management from initial search and filing through registration, maintenance, and enforcement. Unlike limited-service providers, we handle office action responses, oppositions, renewals, and monitoring all under one roof. This integrated approach ensures continuity, consistency, and comprehensive protection of your brand assets.',
    stats: 'End-to-end service'
  },
  {
    title: 'Strategic Trademark Consulting',
    description: 'Beyond filing paperwork, we provide strategic counsel on trademark selection, portfolio management, and brand protection strategy. We advise on trademark strength, help you avoid common pitfalls, recommend international protection when appropriate, and develop comprehensive IP strategies aligned with your business goals.',
    stats: 'Expert consulting'
  },
  {
    title: 'Proactive Communication & Updates',
    description: 'We keep you informed at every stage with proactive status updates, deadline reminders, and prompt responses to questions. You\'ll receive notifications for application milestones, USPTO actions, and important deadlines. Our client portal provides 24/7 access to your case status, documents, and correspondence history.',
    stats: '24/7 case access'
  },
];

export const processSteps = [
  {
    step: 1,
    title: 'Trademark Search & Analysis',
    description: 'We conduct a comprehensive search of existing trademarks to identify potential conflicts. Our detailed analysis includes USPTO database searches, common law searches, and state trademark databases. You receive a complete report with our professional assessment of registration likelihood and potential obstacles.',
  },
  {
    step: 2,
    title: 'Application Preparation & Filing',
    description: 'Our experts prepare your trademark application with precise attention to detail. We select the appropriate trademark classes, draft accurate descriptions of goods/services, and compile required specimens. Your application is then filed electronically with the USPTO, and you receive immediate confirmation and filing details.',
  },
  {
    step: 3,
    title: 'Monitoring & Registration',
    description: 'We monitor your application status and respond to any USPTO office actions on your behalf. Our team handles all examiner communications, objections, and requirements. Once approved, we ensure timely publication, manage opposition periods, and secure your final registration certificate. Post-registration, we provide ongoing monitoring and renewal management.',
  },
];

export const pricingPlans = [
  {
    name: 'Essentials',
    price: '$45',
    subtitle: '+ Federal Filing Fee',
    features: [
      'Case Review',
      'Case Filing',
      'Basic Search',
      'State E-Filing',
      'Trademark Secured',
    ],
    note: '(Govt. filing fee not included)',
    popular: false,
  },
  {
    name: 'Enhanced',
    price: '$149',
    subtitle: '+ Federal Filing Fee',
    features: [
      'Case Review',
      'Case Filing',
      'Direct Hit Search',
      'Trademark Alert',
      'Trademark Secured',
      'High Satisfaction Rate',
      'Refusal Risk Meter',
    ],
    note: '(Govt. filing fee not included)',
    popular: false,
  },
  {
    name: 'Deluxe',
    price: '$299',
    subtitle: '+ Federal Filing Fee',
    features: [
      'Case Review',
      'Case Filing',
      'Direct Hit Search',
      'Trademark Alert',
      'Trademark Secured',
      'High Satisfaction Rate',
      'Refusal Risk Meter',
      'Trademark Monitoring',
      'Complete Documentation',
      'Digital File',
      'Dedicated Case Manager',
    ],
    note: '(Govt. filing fee not included)',
    popular: true,
    recommended: true,
  },
  {
    name: 'Platinum',
    price: '$349',
    subtitle: '+ Federal Filing Fee',
    features: [
      'Case Review',
      'Case Filing',
      'Direct Hit Search',
      'Trademark Alert',
      'Trademark Secured',
      'High Satisfaction Rate',
      'Refusal Risk Meter',
      'Trademark Monitoring',
      'Complete Documentation',
      'Digital File',
      'Dedicated Case Manager',
      'High Approval Rate',
      'Comprehensive Search Report',
      'High Priority Service',
      'Cease & Desist Letter',
    ],
    note: '(Govt. filing fee not included)',
    popular: false,
  },
];

export const industriesServed = [
  { 
    name: 'Technology & Software', 
    icon: 'Laptop',
    description: 'SaaS products, mobile apps, software platforms, tech startups, IT services, cloud solutions, and digital products'
  },
  { 
    name: 'Retail & E-commerce', 
    icon: 'ShoppingBag',
    description: 'Online stores, brick-and-mortar retailers, marketplace sellers, dropshipping businesses, and retail brands'
  },
  { 
    name: 'Food & Beverage', 
    icon: 'Coffee',
    description: 'Restaurants, food brands, beverage companies, catering services, food trucks, breweries, and specialty foods'
  },
  { 
    name: 'Healthcare & Wellness', 
    icon: 'Heart',
    description: 'Medical practices, wellness centers, fitness brands, health apps, supplements, therapeutic services, and telehealth'
  },
  { 
    name: 'Professional Services', 
    icon: 'Briefcase',
    description: 'Consulting firms, law firms, accounting, marketing agencies, business services, and B2B service providers'
  },
  { 
    name: 'Manufacturing & Industrial', 
    icon: 'Factory',
    description: 'Product manufacturers, industrial equipment, component suppliers, fabrication, and industrial services'
  },
  { 
    name: 'Entertainment & Media', 
    icon: 'Film',
    description: 'Production companies, streaming services, podcasts, music labels, gaming, content creators, and digital media'
  },
  { 
    name: 'Fashion & Apparel', 
    icon: 'Shirt',
    description: 'Clothing brands, footwear, accessories, jewelry, fashion e-commerce, designers, and lifestyle brands'
  },
  { 
    name: 'Real Estate & Property', 
    icon: 'Home',
    description: 'Real estate agencies, property management, construction, development firms, and real estate technology'
  },
  { 
    name: 'Education & Training', 
    icon: 'GraduationCap',
    description: 'Educational institutions, online courses, tutoring services, training programs, and EdTech platforms'
  },
  { 
    name: 'Automotive & Transportation', 
    icon: 'Car',
    description: 'Auto services, car dealerships, parts suppliers, transportation services, and automotive technology'
  },
  { 
    name: 'Financial Services', 
    icon: 'DollarSign',
    description: 'Fintech companies, banking services, investment firms, insurance, payment processors, and financial advisors'
  },
  { 
    name: 'Beauty & Cosmetics', 
    icon: 'Heart',
    description: 'Skincare brands, makeup lines, beauty salons, spa services, personal care products, and beauty tech'
  },
  { 
    name: 'Hospitality & Tourism', 
    icon: 'Home',
    description: 'Hotels, resorts, travel agencies, tour operators, vacation rentals, and hospitality services'
  },
  { 
    name: 'Sports & Recreation', 
    icon: 'Trophy',
    description: 'Sports brands, fitness equipment, athletic wear, recreational facilities, sports leagues, and outdoor gear'
  },
  { 
    name: 'Home & Garden', 
    icon: 'Home',
    description: 'Home improvement, furniture, decor, gardening products, home services, and lifestyle home brands'
  },
];

export const benefits = [
  {
    title: 'Exclusive Nationwide Rights',
    description: 'Federal trademark registration grants you exclusive rights to use your mark throughout all 50 states in connection with your specific goods or services. This nationwide protection prevents competitors from using confusingly similar marks anywhere in the United States, securing your market position across the entire country. Unlike state registrations or common law rights that are limited to specific geographic areas, federal registration provides comprehensive territorial coverage essential for businesses operating online or planning expansion into new markets.',
    impact: 'Prevents competitors in all 50 states from using similar marks'
  },
  {
    title: 'Powerful Legal Protection & Enforcement',
    description: 'A registered trademark creates a legal presumption of your ownership and exclusive right to use the mark nationwide. This presumption shifts the burden of proof to challengers and provides significant advantages in litigation. You gain the right to sue for trademark infringement in federal court, seek statutory damages up to $2,000,000 per mark, recover attorney fees and costs, and obtain injunctions to stop infringing use. Federal registration also enables border protection through US Customs to block counterfeit imports.',
    impact: 'Statutory damages up to $2M per mark + attorney fees'
  },
  {
    title: 'Substantial Business Asset Value',
    description: 'Your registered trademark is a valuable intangible asset that appears on your balance sheet and appreciates as your brand gains recognition. Trademarks can be licensed to generate royalty income, franchised to expand your business model, used as collateral for loans and financing, or sold separately from your business. Strong trademark portfolios significantly increase company valuation for investors, acquisitions, or IPOs. Many successful companies have trademark portfolios worth billions of dollars.',
    impact: 'Creates licensable, franchisable, and sellable asset'
  },
  {
    title: 'Market Credibility & Consumer Trust',
    description: 'The ® symbol demonstrates to consumers, partners, and competitors that your brand is legitimate, established, and legally protected. This mark of authenticity builds consumer confidence, enhances brand perception, and signals professional operation. Registered trademarks help consumers distinguish genuine products from counterfeits, protect against consumer confusion, and establish your company as a serious market player. The ® symbol itself acts as a deterrent to potential infringers who recognize you have legal protection.',
    impact: 'Builds consumer trust and deters potential infringers'
  },
  {
    title: 'Digital & Online Brand Protection',
    description: 'Trademark registration provides powerful tools to protect your brand in the digital realm. You can prevent cybersquatters from registering confusingly similar domain names and use UDRP proceedings to recover infringing domains. Social media platforms prioritize trademark holders when handling impersonation and brand abuse complaints. Registered marks help with takedown requests on e-commerce platforms, app stores, and online marketplaces. You can also prevent competitors from bidding on your trademarks in search engine advertising.',
    impact: 'Enables domain recovery and social media protection'
  },
  {
    title: 'Perpetual Protection & Legacy Building',
    description: 'Unlike patents (20 years) or copyrights (life + 70 years), trademarks can last forever as long as you continue using the mark in commerce and file required maintenance documents every 10 years. This unlimited duration allows you to build lasting brand equity that can be passed down through generations. Many iconic trademarks are over 100 years old and continue to be valuable assets. Your trademark can become a legacy that outlives products, business models, and even companies themselves.',
    impact: 'Unlimited protection duration with proper maintenance'
  },
  {
    title: 'Competitive Market Advantage',
    description: 'Trademark registration creates barriers to entry for competitors by preventing them from using your established brand identity. This protection helps you maintain market share, command premium pricing, and build customer loyalty without fear of brand confusion. Your registered mark becomes a unique identifier that differentiates you from competitors and makes it easier for customers to find and choose your products. In crowded markets, this differentiation is often the key to sustainable competitive advantage.',
    impact: 'Creates barriers to entry and maintains market position'
  },
  {
    title: 'International Expansion Foundation',
    description: 'US federal registration serves as the foundation for international trademark protection through treaties like the Madrid Protocol. Your US registration date becomes your priority date in over 120 countries, preventing others from registering your mark abroad. This is crucial for businesses planning global expansion, exporting products, or operating in international markets. Federal registration also demonstrates to foreign trademark offices that your mark is in use and worthy of protection in their jurisdictions.',
    impact: 'Establishes priority for international registration'
  },
];

export const trustSignals = [
  { title: 'USPTO Filing Experts', description: 'Certified and experienced with federal trademark procedures' },
  { title: '1000+ Trademarks Filed', description: 'Successfully filed and registered for businesses nationwide' },
  { title: '98% Approval Rate', description: 'Industry-leading success rate with USPTO applications' },
  { title: 'A+ BBB Rating', description: 'Accredited business with excellent customer reviews' },
];

export const faqData = [
  {
    question: 'How long does the trademark registration process take?',
    answer: 'The trademark registration process typically takes 8-12 months from filing to final registration. This includes USPTO examination time, publication period, and final approval. The timeline can vary based on office actions, oppositions, or other complications. We monitor your application throughout and keep you informed of all progress.',
  },
  {
    question: 'What is the difference between ™ and ® symbols?',
    answer: 'The ™ symbol can be used with any mark you claim as a trademark, even before registration. The ® symbol is reserved exclusively for federally registered trademarks with the USPTO. Using ® without federal registration is illegal and can result in penalties. Once your trademark is registered, you should use ® to maximize legal protection.',
  },
  {
    question: 'Do I need to register my trademark in every state?',
    answer: 'No. Federal trademark registration with the USPTO provides nationwide protection across all 50 states. This is more comprehensive and cost-effective than registering in individual states. Federal registration also provides additional benefits including federal court access, customs protection, and stronger legal presumptions of ownership.',
  },
  {
    question: 'What can be trademarked?',
    answer: 'You can trademark words, phrases, logos, symbols, designs, slogans, and even sounds or colors in certain cases. The mark must be distinctive and used in commerce to identify your goods or services. Generic terms and purely descriptive phrases typically cannot be trademarked. We help assess whether your mark qualifies for protection.',
  },
  {
    question: 'What are trademark classes and how many do I need?',
    answer: 'Trademark classes categorize different types of goods and services. There are 45 international classes total. You must register in each class where you use or plan to use your mark. Most businesses need 1-3 classes. Each class requires a separate filing fee. We help identify the appropriate classes for your business.',
  },
  {
    question: 'What happens if someone opposes my trademark application?',
    answer: 'After your mark is published, there is a 30-day opposition period where third parties can challenge your application. If an opposition is filed, it initiates a proceeding similar to litigation. Our experienced team represents you in opposition proceedings and works to overcome challenges to secure your registration.',
  },
  {
    question: 'How much does trademark registration cost?',
    answer: 'Our service fees range from $45 to $349 depending on the package you choose. Additionally, USPTO filing fees apply ($250-$350 per class). There are no hidden fees, and we provide transparent pricing upfront. The total investment protects your brand for 10 years, with renewal options to maintain protection indefinitely.',
  },
  {
    question: 'Can I trademark a name that is similar to an existing trademark?',
    answer: 'It depends on several factors including the similarity of the marks, the relatedness of the goods/services, and the strength of the existing mark. Our comprehensive trademark search identifies potential conflicts, and we provide a professional assessment of registration likelihood. We help you understand risks before filing.',
  },
];

export const ctaData = {
  title: 'Protect Your Brand Today - Don\'t Wait Until It\'s Too Late',
  subtitle: 'Every day without trademark protection puts your brand at risk. Competitors can file applications for similar marks, cybersquatters can register confusingly similar domains, and counterfeiters can dilute your brand value. The trademark registration process takes 8-12 months, so delays cost you months of vulnerability. Secure your brand rights now before someone else claims a similar mark in your industry.',
  stats: [
    { value: '8-12', label: 'Months to Register', description: 'Start your protection today' },
    { value: '$2M', label: 'Potential Damages', description: 'If someone infringes your mark' },
    { value: '24-48hr', label: 'Application Filing', description: 'Fast processing time' },
  ],
  urgency: 'First-to-file system means whoever files first gets the trademark rights, regardless of who used it first. Don\'t lose your brand to a competitor.',
  image: 'https://images.unsplash.com/photo-1730382624709-81e52dd294d4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwxfHxidXNpbmVzcyUyMGdyb3d0aHxlbnwwfHx8fDE3NzU4NjA4NTd8MA&ixlib=rb-4.1.0&q=85',
};

export const countryCodes = [
  { code: '+1', country: 'United States' },
  { code: '+1', country: 'Canada' },
  { code: '+44', country: 'United Kingdom' },
  { code: '+91', country: 'India' },
  { code: '+86', country: 'China' },
  { code: '+81', country: 'Japan' },
  { code: '+49', country: 'Germany' },
  { code: '+33', country: 'France' },
  { code: '+39', country: 'Italy' },
  { code: '+34', country: 'Spain' },
  { code: '+61', country: 'Australia' },
  { code: '+55', country: 'Brazil' },
  { code: '+52', country: 'Mexico' },
];
